import { graphql } from 'src/graphql';

export const HeaderViewer = graphql(`
  query HeaderViewer {
    viewer {
      _id
      _default_team
      type {
        researcher
        client
      }
      ConnectedTeam {
        _id
        Organisation {
          _id
          settings {
            disallow_multiple_team_sign_on
          }
        }
        ParentTeam {
          _id
          users {
            _id
            role
          }
        }
        settings {
          billing {
            subscription {
              credit {
                remaining
              }
            }
          }
        }
      }
    }
  }
`);
